import { Link } from '@tanstack/react-router'
import { Plus, Upload, UserCircle2 } from 'lucide-react'

import { Button } from '@/components/button/button'

import { useRegisterApplicant } from './dialogs/hooks/use-register-applicant'

export const EmptyDashboard = () => {
  const { openDialog: openRegisterApplicantDialog } = useRegisterApplicant()

  return (
    <div className="animate-fade-in">
      {/* HEADER */}
      <div className="font-medium text-muted-foreground">Applicant</div>
      <div className="text-2xl font-bold">New Applicant</div>
      <div className="my-6 h-[1px] w-full bg-border" />

      {/* ADD NEW APPLICANT */}
      <div className="flex flex-col items-center pt-[140px]">
        <UserCircle2 className="mb-4 text-muted-foreground" size={40} />
        <div className="pb-4 text-center text-lg font-semibold">
          <div>You have not added any applicants.</div>
          <div>Add one below.</div>
        </div>
        <div className="flex space-x-4">
          <Link to="/import">
            <Button variant="secondary" asChild>
              <div>
                <Upload className="mr-2" size={17} />
                <span>Bulk upload cases</span>
              </div>
            </Button>
          </Link>
          <Button onClick={openRegisterApplicantDialog}>
            <Plus size={16} />
            <span className="pl-2">Add Applicant</span>
          </Button>
        </div>
      </div>
    </div>
  )
}
